import moment from 'moment';
import { countryCodes } from '../../../shared/lib/country-codes-iso-alpha-2';

const defaultSelectedDate = moment.utc();

const inputObjectDefaults = {
  includeCargo: { name: 'exportFormincludeCargo', type: 'bool', value: false },
  includeCodeshares: { name: 'exportFormIncludeCodeshares', type: 'bool', value: false },
  selectedStartDate: { name: 'exportFormStartDate', type: 'date', value: moment.utc(moment(defaultSelectedDate).subtract(2, 'days')) },
  selectedEndDate: { name: 'exportFormEndDate', type: 'date', value: moment.utc(moment(defaultSelectedDate).subtract(1, 'day')) },
  userExportIntendedUse: { name: 'userExportIntendedUse', type: 'text', value: '' },
  userIndustrySelect: { name: 'userExportIndustrySelect', type: 'select', value: null },
};

const dataExportRegions = {
  northAmerica: 'north_america',
  oceania: 'oceania',
  africa: 'africa',
  latinAmerica: 'latin_america',
  europe: 'europe',
  antarctica: 'antarctica',
  asia: 'asia',
  all: 'world',
};

const noPollForStatuses = {
  counting: true,
  count_pending: true,
  count_failed: true,
  charge_failed: true,
  charge_succeeded: true,
  downloading: true,
  download_succeeded: true,
  download_failed: true,
  notifying: true,
  notify_succeeded: true,
  notify_failed: true,
};

const previousDataExportScreenStatuses = {
  generating: true,
  generate_succeeded: true,
  generate_failed: true,
  downloading: true,
  download_succeeded: true,
  download_failed: true,
  charging: true,
  charge_succeeded: true,
  charge_failed: true,
  notifying: true,
  notify_succeeded: true,
  notify_failed: true,
};

const exportTypeTitles = {
  departing: 'Departing',
  arriving: 'Arriving',
  deparr: 'Departing/Arriving',
  route: 'Route',
};

const categoryTypePrefixMapping = {
  historical: 'flight_status_by_',
};

const filterTypeMapping = {
  airport: ['arrivalAirports', 'departureAirports'],
  country: ['countries'],
  region: ['regions'],
};

const referenceDataValidationMap = {
  airport: ['arrivalAirports', 'departureAirports'],
  countries: ['arrivalCountries', 'departureCountries'],
  regions: ['arrivalRegions', 'departureRegions'],
};

// ** constants for /home (previous data exports) **

const exportsOptionOpen = NaN;
const timers = {};

// ** end constants for /home (previous data exports) **

export {
  countryCodes,
  dataExportRegions,
  defaultSelectedDate,
  exportsOptionOpen,
  exportTypeTitles,
  filterTypeMapping,
  inputObjectDefaults,
  referenceDataValidationMap,
  timers,
  categoryTypePrefixMapping,
  noPollForStatuses,
  previousDataExportScreenStatuses,
};



// WEBPACK FOOTER //
// ./modules/DataExports/redux/data-constants.js